module.exports = __webpack_public_path__ + "img/timer.d8d8aed7.svg";